import { lazy } from 'react';
import { Navigate, createHashRouter } from 'react-router-dom';
import { App } from './App';
import { FeatureRoute } from './auth/FeatureRoute';

const loadDashboard = () => import('./pages/Dashboard').then(module => ({ default: module.Dashboard }));
const Dashboard = lazy(loadDashboard);
const loadModelLibrary = () => import('./pages/ModelLibrary').then(module => ({ default: module.ModelLibrary }));
const ModelLibrary = lazy(loadModelLibrary);
const loadTryOnWorkspace = () => import('./pages/TryOnWorkspace').then(module => ({ default: module.TryOnWorkspace }));
const TryOnWorkspace = lazy(loadTryOnWorkspace);
const loadShowcaseWorkspace = () => import('./pages/ShowcaseWorkspace').then(module => ({ default: module.ShowcaseWorkspace }));
const ShowcaseWorkspace = lazy(loadShowcaseWorkspace);
const loadTaskQueue = () => import('./pages/TaskQueue').then(module => ({ default: module.TaskQueue }));
const TaskQueue = lazy(loadTaskQueue);
const loadResults = () => import('./pages/Results').then(module => ({ default: module.Results }));
const Results = lazy(loadResults);
const loadAbout = () => import('./pages/About').then(module => ({ default: module.About }));
const About = lazy(loadAbout);
const loadAccount = () => import('./pages/Account').then(module => ({ default: module.Account }));
const Account = lazy(loadAccount);
const loadResourceSubmissions = () => import('./pages/ResourceSubmissions').then(module => ({ default: module.ResourceSubmissions }));
const ResourceSubmissions = lazy(loadResourceSubmissions);
const loadAdminConsole = () => import('./pages/admin/AdminConsole').then(module => ({ default: module.AdminConsole }));
const AdminConsole = lazy(loadAdminConsole);
const loadFabricTryOnWorkspace = () => import('./pages/FabricTryOnWorkspace').then(module => ({ default: module.FabricTryOnWorkspace }));
const FabricTryOnWorkspace = lazy(loadFabricTryOnWorkspace);
const loadFabricDisplayWorkspace = () => import('./pages/FabricDisplayWorkspace').then(module => ({ default: module.FabricDisplayWorkspace }));
const FabricDisplayWorkspace = lazy(loadFabricDisplayWorkspace);

// Start only the requested page's static chunk alongside authentication. The
// component still mounts behind AuthProvider/FeatureRoute; this runs no page APIs.
const initialPage = window.location.hash.slice(1).split('?')[0] || '/';
const initialPageLoaders: Record<string, () => Promise<unknown>> = {
  '/': loadDashboard,
  '/models': loadModelLibrary,
  '/tryon': loadTryOnWorkspace,
  '/showcase': loadShowcaseWorkspace,
  '/tasks': loadTaskQueue,
  '/results': loadResults,
  '/about': loadAbout,
  '/account': loadAccount,
  '/submissions': loadResourceSubmissions,
  '/admin': loadAdminConsole,
  '/fabric-tryon': loadFabricTryOnWorkspace,
  '/fabric-display': loadFabricDisplayWorkspace,
};
void initialPageLoaders[initialPage]?.().catch(() => undefined);

export const router = createHashRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { path: '/', element: <Dashboard /> },
      { path: '/models', element: <ModelLibrary /> },
      { path: '/tryon', element: <FeatureRoute feature="tryon"><TryOnWorkspace /></FeatureRoute> },
      { path: '/fabric-tryon', element: <FeatureRoute feature="fabric-tryon"><FabricTryOnWorkspace /></FeatureRoute> },
      { path: '/fabric-display', element: <FeatureRoute feature="fabric-display"><FabricDisplayWorkspace /></FeatureRoute> },
      { path: '/showcase', element: <FeatureRoute feature="garment-display"><ShowcaseWorkspace /></FeatureRoute> },
      { path: '/tasks', element: <TaskQueue /> },
      { path: '/results', element: <Results /> },
      { path: '/submissions', element: <ResourceSubmissions /> },
      { path: '/submissions/prompts', element: <Navigate to="/submissions?type=prompt" replace /> },
      { path: '/submissions/models', element: <Navigate to="/submissions?type=model" replace /> },
      { path: '/account', element: <Account /> },
      { path: '/admin', element: <AdminConsole /> },
      { path: '/about', element: <About /> },
    ],
  },
]);
